import { useTheme } from '@emotion/react';
import { Avatar, Box, Chip, Grid, Typography, useMediaQuery, Checkbox, Select, Pagination, MenuItem, Switch, alpha, Paper, Tooltip, TableContainer, Rating } from '@mui/material';
import React, { memo } from 'react';
import { useTable } from 'react-table';
import PerfectScrollbar from "react-perfect-scrollbar";
import { amountInWords, bindShiftWheelScroll, capitalizedSentence, containerRef, getFileCategory, hasPermission, stringAvatar } from "../utils";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Secondary } from './Buttons';
import { ReactComponent as PreviousIcon } from "../assets/table-previous.svg";
import { ReactComponent as DownIcon } from "../assets/table-chevron-down.svg";
import { ReactComponent as NextIcon } from "../assets/table-next.svg";
import NoData from './NoData';
import { styled } from '@mui/styles';
import ModalComponent from './ModalComponent';
import { Add } from '@mui/icons-material';
import ShowInterestPopup from 'views/startup_applications/popups/ShowInterestPopup';
import ImageIcon from 'common-components/ImageIcon';
import { SaveInterest } from 'api/startup_applications';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import ImageAvatar from './ImageAvatar';
import { EditInvestorPopupPostApi } from 'api/org/round';
import LeadInvestorControlPopup from './popups/DeleteConfirmationPopup';
import AddInvestorPopup from 'views/startups/rounds/popups/AddInvestorPopup';
import { FetchAllCurrencyLists } from 'api/utils';

const CustomSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: "#e0e0e0",
        '&:hover': {
            backgroundColor: alpha("#000000", theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: "#000000",
    },
}));

const StatusChip = ({ cell }) => {
    const [openModal, setOpenModal] = React.useState(false)

    const statusStyleSwitch = (value) => {
        switch (value) {
            case "Invited": return { color: '#d4a72d', bgcolor: '#fef8e8' };
            case "Added": return { color: '#39739d', bgcolor: '#e1ecf4' };
            case "Interested": return { color: '#1b5e20', bgcolor: '#e8f5e9' };
            case "Rejected": return { color: '#d32f2f', bgcolor: '#ffebee' };
            case "Pending": return { color: '#ff9800', bgcolor: '#fff3e0' };
            case "Completed": return { color: '#673ab7', bgcolor: '#ede7f6' };
            case "Received": return { color: '#00695c', bgcolor: '#e0f2f1' };
            case "Sent": return { color: '#1565c0', bgcolor: '#e3f2fd' };
            case "Backrr": return { color: '#00695c', bgcolor: '#e0f2f1' };
            case "Self": return { color: '#1565c0', bgcolor: '#e3f2fd' };
            case "Paid": return { color: '#1b5e20', bgcolor: '#e0f2f1' };
            case "Free": return { bgcolor: "#F9F5FF", color: "#3538CD" };
            case "Active": return { color: '#1b5e20', bgcolor: '#e0f2f1' };
            case "Expired": return { color: '#d32f2f', bgcolor: '#ffebee'  };
            default: return ({ bgcolor: "#F9F5FF", color: "#3538CD" })
        }
    }

    return (
        <>
            {/* <ModalComponent open={openModal} onClose={() => setOpenModal(false)} style={{ maxWidth: 600 }}>
                <Paper>
                    {cell.column.id === "documents" ? <AddSHADocumentsPopup /> : <UpdateStatusPopup handleClose={() => setOpenModal(false)} />}
                </Paper>
            </ModalComponent> */}
            <Chip
                style={{ borderRadius: '4px' }}
                variant='filled'
                label={cell?.value}
                sx={{ marginInline: 'auto', ...statusStyleSwitch(cell?.value) }}
            // clickable
            // onClick={() => { setOpenModal(true) }}
            />
        </>
    )
}

const AsyncTableListing = (
    {
        columns = [],
        data = [],
        title,
        tableCardHeaderStyle = {},
        actions: Actions,
        RowActions = () => { },
        chipText = "",
        CustomLink = ({ children }) => (<>{children}</>),
        backgroundColor = '#fff',
        page = 1,
        setPage = () => { },
        limit = 20,
        setLimit = () => { },
        pagination = true,
        count,
        sx,
        tabValue = "",
        refetchListing = () => { },
        tableHeadStyles = {},
        noDataTitle = "No Data Available",
        noDataSubTitle = "It seems like there is no data available at the moment.",
        noDataPlaceHolderImage = null,
        noDataPlaceHolderSx = {},
        maxHeight,
        reset = false,
        pageCookieName
    }
) => {
    const [investor_id, setInvestorID] = React.useState(Cookies.get("X-ADMIN-ID") || null);
    const [searchParams, setSearchParams] = useSearchParams()
    const theme = useTheme();
    const navigate = useNavigate();
    const matchesUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const userPermissions = useSelector((state) => state?.permissions?.userPermissions);

    const [openAddInvestorModal, setOpenAddInvestorModal] = React.useState(false);
    const [currentRow, setCurrentRow] = React.useState(false);

    const handleAddInvestorClose = () => {
        setOpenAddInvestorModal(false)
        setCurrentRow(null)
    }
    const handleAddInvestorSubmit = () => {
        setOpenAddInvestorModal(false)
        setCurrentRow(null)
    }
    const canPreviousPage = page > 1;
    const canNextPage = page < Math.ceil(count / limit);

    const previousPage = () => {
        if (canPreviousPage) {
            setPage(page - 1);
            pageCookieName && Cookies.set(pageCookieName, page - 1)
            // if (searchParams?.get("p")) {
            //     searchParams.set('p', page - 1);
            //     setSearchParams(searchParams);
            // } else {
            //     searchParams.append('p', page - 1);
            //     setSearchParams(searchParams);
            // }
        }
    };

    const nextPage = () => {
        if (canNextPage) {
            setPage(page + 1);
            pageCookieName && Cookies.set(pageCookieName, page + 1)
            // if (searchParams?.get("p")) {
            //     searchParams.set('p', page + 1);
            //     setSearchParams(searchParams);
            // } else {
            //     searchParams.append('p', page + 1);
            //     setSearchParams(searchParams);
            // }
        }
    };

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows, // Full data without pagination
        prepareRow,
    } = useTable({
        columns,
        data: Array.isArray(data) ? data : [],
        initialState: { pageIndex: 0 },
    });

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isTabletScreenOrBelow = useMediaQuery(theme.breakpoints.down('md'));

    const DocumentIcon = ({ row, value }) => {
        const theme = useTheme();
        // console.log(row,cell.value,"rc")
        return <Box width={isSmallScreen ? 35 : 40} height={isSmallScreen ? 35 : 40} bgcolor={theme?.palette?.customColors?.indigo100} borderRadius={"4px"} display={"flex"} alignItems="center" justifyContent={"center"}>
            <img src={getFileCategory(value)} width={20} height={20} />
        </Box>
    }

    const CustomToggle = ({ cell, row }) => {
        const { status, ...currentRow } = row?.original
        const round_id = Cookies.get("round_id")
        // const { id: round_id } = useParams();
        const currentColumn = cell.column.id;
        const enabled = !cell.column.disabled

        const {
            mutateAsync: editInvestorAsync,
            isLoading: isUpdatingInvestor,
            status: editInvestorStatus,
            error: editInvestorError,
            data: editInvestorResponse
        } = EditInvestorPopupPostApi();

        // Construct details object dynamically based on the column being updated

        const [openModal, setOpenModal] = React.useState(false);

        const handleClose = () => {
            setOpenModal(false);
        };

        const handleSubmission = async () => {
            currentRow[currentColumn] = !(cell.value);
            await editInvestorAsync({ payload: currentRow, _id: round_id }).then(() => {
                refetchListing();
                handleClose();
            })
        };

        const shouldRenderModal = [
            "lead_investor",
            "kyc",
            "agreement_signed",
            "call_for_money",
            "fund_received"
        ].includes(currentColumn);

        return (
            <>
                {shouldRenderModal && (
                    <LeadInvestorControlPopup
                        open={openModal}
                        handleClose={handleClose}
                        handleSubmission={handleSubmission}
                        heading={`Update ${capitalizedSentence(currentColumn.replaceAll("_", " "))} Status`}
                        ActionText="Confirm"
                        subheading={`Are you sure you want to update ${currentColumn.replaceAll("_", " ")} status?`}
                    />
                )}
                <CustomSwitch
                    disabled={!hasPermission("startups_new", "edit", userPermissions)}
                    checked={cell.value}
                    cell={cell}
                    row={currentRow}
                    onClick={() => {
                        enabled && setOpenModal(true)
                    }}
                />
            </>
        );
    };

    const [openShowInterestPopup, setOpenShowInterestPopup] = React.useState();

    const handleShowInterestPopupOpen = ({ row }) => {
        setCurrentRow(row)
        setOpenShowInterestPopup(true);
    }

    const handleShowInterestPopupClose = () => {
        setOpenShowInterestPopup(false)
        setCurrentRow(null)
    }

    const {
        mutateAsync: saveInterestAsync,
        status: saveInterestStatus,
        error: saveInterestError,
        isLoading: isSavingInterest,
        data: saveInterestResponse,
    } = SaveInterest();

    const handleShowInterestPopupSubmit = ({ row, values }) => {
        // console.log(row, "row")
        let request = {
            startup_id: row?._id,
            interested_amount: Number(String(values?.interested_amount)?.replaceAll(",", "")) || 0,
            investor_id: investor_id,
            currency_id: values?.currency_id
        }
        // console.log(request, "request");
        saveInterestAsync(request).then(() => {
            refetchListing()
        })
        handleShowInterestPopupClose();
    }

    const { data: currencyList, isLoading: isLoadingCurrency } =
        FetchAllCurrencyLists();

    // React.useEffect(() => {
    //     if (pagination) {
    //         if (Cookies.get("backrr_table_page") && Number(Cookies.get("backrr_table_page"))) {
    //             if (Number(Cookies.get("backrr_table_page")) > Math.ceil(count / limit)) {
    //                 setPage(1)
    //                 Cookies.remove("backrr_table_page");
    //                 // searchParams.delete("p");
    //                 // setSearchParams(searchParams);
    //             }
    //             else {
    //                 // console.log(Number(searchParams?.get('p')), "New")
    //                 setPage(Number(Cookies.get("backrr_table_page")) || 1)
    //             }
    //         }
    //         // if (searchParams?.get('p') && Number(searchParams?.get('p'))) {
    //         //     if (Number(searchParams?.get('p')) > Math.ceil(count / limit)) {
    //         //         setPage(1)
    //         //         searchParams.delete("p");
    //         //         setSearchParams(searchParams);
    //         //     }
    //         //     else {
    //         //         // console.log(Number(searchParams?.get('p')), "New")
    //         //         setPage(Number(searchParams?.get('p')) || 1)
    //         //     }
    //         // }
    //         // else {
    //         //     searchParams.append('p', 1);
    //         //     setSearchParams(searchParams)
    //         // }
    //     }
    // }, [page, Cookies])
    // }, [page, searchParams.get('p')])

    // React.useEffect(() => {
    //     // setPage(1);
    //     if
    //     searchParams.set()
    //     // console.log(Number(searchParams?.get('p')))
    // }, [reset])

    return (
        <>
            <ModalComponent open={openShowInterestPopup} onClose={handleShowInterestPopupClose} style={{ maxWidth: 640, width: "100%" }}>
                <ShowInterestPopup currentRow={currentRow} handleClose={handleShowInterestPopupClose} handleSubmit={handleShowInterestPopupSubmit} />
            </ModalComponent>
            <ModalComponent open={openAddInvestorModal} onClose={handleAddInvestorClose} style={{ maxWidth: 640, width: "100%" }}>
                <AddInvestorPopup currentRow={currentRow} value={tabValue} handleClose={handleAddInvestorClose} handleSubmit={handleAddInvestorSubmit} refetchListing={refetchListing} />
            </ModalComponent>
            {data?.length > 0 ? <Grid container xs={12} className='table-container' border={`1px solid #EAEAEE`} boxShadow={'0px 2px 12px 0px rgba(15, 23, 41, 0.04)'} sx={{ ...sx, borderRadius: sx ? sx?.borderRadius : '16px' }} bgcolor={backgroundColor}
                maxHeight={pagination && count > 10 ? "calc(100dvh - 14.5rem)" : "calc(100dvh - 14rem)"}
                height={"100%"} overflow={"hidden"}>
                {title && <Grid container item xs={12} sx={{ display: "flex", justifyContent: "space-between", padding: "1rem 1.5rem", alignItems: "center", ...tableCardHeaderStyle }} >
                    <Box display={"flex"} alignItems={"center"} gap={"0.5rem"}>
                        <Typography color={theme.palette.customColors.g300} sx={{ fontSize: '18px', fontWeight: 500, lineHeight: "28px", textAlign: 'left' }}>
                            {title}
                        </Typography>
                        {chipText && <Chip label={chipText} size='small' sx={{ padding: '0.125rem 0.5rem !important', color: "#6941C6", bgcolor: '#F9F5FF', "& > .MuiChip-label": { padding: 0 } }} />}
                    </Box>
                    {Actions && <Actions />}
                </Grid>}

                {/* <PerfectScrollbar containerRef={containerRef} style={{ height: '100%', maxHeight: matchesUpMd ? '44vh' : '40dvh', width: '100%' }}> */}
                <PerfectScrollbar containerRef={(ref) => { containerRef(ref); bindShiftWheelScroll(ref); }} style={{ height: '100%', maxHeight: maxHeight ? maxHeight : ((pagination && count > 10) ? (matchesUpMd ? 'calc(100dvh - 19.6rem)' : 'calc(100dvh - 19.6rem)') : "100%"), width: '100%' }}>
                    {/* <TableContainer sx={{ height: '100%', maxHeight: matchesUpMd ? '100%' : '100%', width: '100%' }}> */}
                    <table style={{ width: '100%', ...(pagination && count > 10 ? { marginBottom: "4.4375rem" } : {}) }} {...getTableProps()}>
                        <thead style={{ position: 'sticky', zIndex: 1000, top: 0, backgroundColor: theme.palette.background.default, ...tableHeadStyles }}>
                            {headerGroups?.map(headerGroup => (
                                <tr
                                    key={headerGroup.id}
                                    style={{
                                        fontSize: "12px", fontWeight: 500, lineHeight: '18px', textAlign: "left",
                                        color: theme.palette.customColors.g100
                                    }}
                                    {...headerGroup.getHeaderGroupProps()}
                                >
                                    {headerGroup?.headers?.map((column, index) => {
                                        const isFixed = column.fixed && !isTabletScreenOrBelow;
                                        if (column?.id === 'checkbox') {
                                            return (
                                                <th style={{ minWidth: column?.minWidth, textAlign: column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={column?.align} key={column.id} {...column.getHeaderProps()}><Checkbox style={{ height: 20, width: 20, color: "#7c4dff" }} /></th>
                                            )
                                        }
                                        else if (column?.id === 'report_actions' && count > 2) {
                                            return (
                                                <th style={{ minWidth: column?.minWidth, textAlign: column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={column?.align} key={column.id} {...column.getHeaderProps()}>
                                                    {data?.length > 0 && <Typography
                                                        onClick={() => { navigate(`/reports/view`) }}
                                                        sx={{
                                                            textAlign: "center",
                                                            color: theme.palette.customColors.indigo600,
                                                            fontSize: '0.75rem',
                                                            cursor: 'pointer'
                                                        }}
                                                    >View All ({count})</Typography>}
                                                </th>
                                            )
                                        }
                                        return (
                                            <th style={{ minWidth: column?.minWidth, textAlign: column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={column?.align} key={column.id} {...column.getHeaderProps()}>{column.render('Header')}</th>
                                        )
                                    })}


                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {rows?.length > 0 && rows?.map((row, idx) => {
                                prepareRow(row);
                                return (
                                    <tr key={row.id} {...row.getRowProps()}>
                                        {row?.cells?.map((cell, index) => {
                                            const isFixed = cell.column.fixed && !isTabletScreenOrBelow;
                                            if (cell.column?.id === 'checkbox') {
                                                return (
                                                    <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align }} align={cell.column?.align}><Checkbox style={{ height: 20, width: 20, color: "#7c4dff" }} sx={{
                                                        '& .MuiSvgIcon-root': {
                                                            borderRadius: '8px',  // Change the border-radius value here
                                                        }
                                                    }} /></td>
                                                )
                                            }
                                            if (cell.column.id === "name") {
                                                {/* console.log(cell.row.original.image,"efef") */ }
                                                if (CustomLink) {
                                                    return (
                                                        <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>
                                                            <CustomLink row={row} cell={cell}>
                                                                <Box
                                                                    sx={{
                                                                        display: 'flex', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px', cursor: 'pointer'
                                                                    }}>
                                                                    <ImageAvatar src={cell?.row?.original?.image || ""} updatedDate={cell?.row?.original?.updatedAt ?? null} alt={cell?.value} />
                                                                    <Box>
                                                                        {cell?.value && cell?.value != "" && <Typography fontWeight={600} sx={{ textWrapMode: "nowrap" }} >
                                                                            {cell?.value}
                                                                        </Typography>
                                                                        }{!cell?.column?.hideEmail && <Typography fontSize={cell?.value && cell?.value != "" ? "0.7rem" : '0.9rem'}>
                                                                            {cell?.row?.original?.email}
                                                                        </Typography>}
                                                                    </Box>
                                                                </Box>
                                                            </CustomLink>
                                                        </td>
                                                    );
                                                }
                                                return (
                                                    <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>
                                                        <Box sx={{
                                                            display: 'flex', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px'
                                                        }}>
                                                            <ImageAvatar src={cell?.row?.original?.image || ""} alt={cell?.value} />
                                                            <Box>
                                                                {cell?.value && cell?.value != "" && <Typography sx={{ textWrapMode: "nowrap" }} >
                                                                    {cell?.value}
                                                                </Typography>
                                                                }{!cell?.column?.hideEmail && <Typography fontSize={cell?.value && cell?.value != "" ? "0.7rem" : '0.9rem'}>
                                                                    {cell?.row?.original?.email}
                                                                </Typography>}
                                                            </Box>
                                                        </Box>
                                                    </td>
                                                );
                                            }

                                            else if (cell.column.id === "document_name") {
                                                const extension = cell?.row?.original?.filename?.split(".")?.pop();
                                                if (cell.column?.trim) {
                                                    if (CustomLink) {
                                                        return (
                                                            <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>
                                                                <CustomLink row={row} cell={cell}>
                                                                    <Box sx={{
                                                                        display: 'flex', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px', cursor: 'pointer',
                                                                    }}>
                                                                        <DocumentIcon value={String(cell.value)?.substring(0, cell.column?.trim) + "." + extension} row={row} /> {String(cell.value)?.substring(0, cell.column?.trim)}
                                                                    </Box>
                                                                </CustomLink>
                                                            </td>
                                                        );
                                                    }
                                                    return (
                                                        <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>
                                                            <Box sx={{
                                                                display: 'flex', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px'
                                                            }}>
                                                                <DocumentIcon value={String(cell.value)?.substring(0, cell.column?.trim) + "." + extension} row={row} /> {String(cell.value)?.substring(0, cell.column?.trim)}
                                                            </Box>
                                                        </td>
                                                    );
                                                }
                                                return (
                                                    <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>
                                                        <Box sx={{
                                                            display: 'flex', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px'
                                                        }}>
                                                            <DocumentIcon value={String(cell.value)?.substring(0, cell.column?.trim) + "." + extension} row={row} /> {String(cell.value)?.substring(0, 50) + "." + extension}
                                                        </Box>
                                                    </td>
                                                );
                                            }
                                            else if (cell.column.id === "filename") {
                                                const extension = cell?.row?.original?.filename?.split(".")?.pop();
                                                if (cell.column?.trim) {
                                                    return (
                                                        <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>
                                                            <Box sx={{
                                                                display: 'flex', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px'
                                                            }}>
                                                                <DocumentIcon value={String(cell.value)?.substring(0, cell.column?.trim) + "." + extension} row={row} /> {cell.render('Cell')}
                                                            </Box>
                                                        </td>
                                                    );
                                                }
                                                return (
                                                    <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>
                                                        <Box sx={{
                                                            display: 'flex', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px'
                                                        }}>
                                                            <DocumentIcon value={String(cell.value)?.substring(0, cell.column?.trim) + "." + extension} row={row} /> {cell.render('Cell')}
                                                        </Box>
                                                    </td>
                                                );
                                            }
                                            else if (cell.column.id === "actions" || cell.column.id === "report_actions") {
                                                return (
                                                    <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>
                                                        <Box sx={{
                                                            display: 'flex', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '0px', justifyContent: cell.column?.align
                                                        }}>
                                                            <RowActions cell={cell} row={row} />
                                                        </Box>
                                                    </td>
                                                );
                                            }
                                            else if (cell.column.id === "status" || cell.column.id === "pipeline_status" || cell.column.clickable || cell.column.status) {
                                                return (
                                                    <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>
                                                        <Box sx={{
                                                            display: 'flex', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px'
                                                        }}>
                                                            <StatusChip cell={cell} row={row} />
                                                        </Box>
                                                    </td>
                                                );
                                            }
                                            else if (["problem", "market", "product", "team", "traction"]?.includes(cell.column.id)) {
                                                return (
                                                    <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>
                                                        <Box sx={{
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px'
                                                        }}>
                                                            <Rating value={cell?.value} precision={0.5} readOnly />
                                                        </Box>
                                                    </td>
                                                );
                                            }
                                            else if (cell.column.toggle) {
                                                return (
                                                    <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>
                                                        <Box sx={{
                                                            display: 'flex', alignItems: 'center', justifyContent: cell.column?.align, color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px'
                                                        }}>
                                                            <CustomToggle cell={cell} row={row} checked={cell.value} />

                                                        </Box>
                                                    </td>
                                                );
                                            }
                                            if (cell.column.id === "statusWithDate") {
                                                return (
                                                    <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}><Typography>{cell.value}</Typography></td>
                                                );
                                            }
                                            if (cell.column.id === "interested_amount_ref" || cell.column.id === "allocated_amount_ref") {
                                                const tooltipField = cell?.column?.tooltip;
                                                const removePrefixSuffix = (str) => {
                                                    if (str.startsWith("formatted_")) {
                                                        return str.slice(10); // Remove "formatted_" (10 characters)
                                                    }
                                                    if (str.endsWith("_ref")) {
                                                        return str.slice(0, -4); // Remove "_ref" (4 characters)
                                                    }
                                                    return str;
                                                };
                                                const currentValue = row.original[removePrefixSuffix(cell.column.id)];
                                                return (
                                                    <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>

                                                        <Box sx={{
                                                            display: 'grid', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px'
                                                        }}>
                                                            {cell.row?.original?.status != "Invited" && cell?.value != "" && cell?.value && cell?.value != null && currentValue != "0" && String(cell?.value)?.trim()?.length !== 0 ?
                                                                <Tooltip title={row?.original[tooltipField]}>
                                                                    <Box>
                                                                        <Typography>
                                                                            {cell.value}
                                                                        </Typography>
                                                                        <Typography fontSize={"0.7rem"}>
                                                                            {cell.row.original.date}
                                                                        </Typography>
                                                                    </Box>
                                                                </Tooltip> : <Box onClick={() => {
                                                                    // console.log("fefef")
                                                                    if (hasPermission("startups_new", "edit", userPermissions)) {
                                                                        setOpenAddInvestorModal(true);
                                                                        setCurrentRow(cell.row?.original)
                                                                    }

                                                                }} display={"flex"} alignItems={"center"} justifyContent={"center"} sx={{ textDecoration: "underline", textUnderlineOffset: '5px', textDecorationColor: hasPermission("startups_new", "edit", userPermissions) ? "#3538CD" : "rgba(0, 0, 0, 0.26)", cursor: 'pointer' }}>
                                                                    <Add style={{ width: 20, height: 20, color: hasPermission("startups_new", "edit", userPermissions) ? "#3538CD" : "rgba(0, 0, 0, 0.26)" }} />
                                                                    <Typography fontSize={"0.9rem"} color={hasPermission("startups_new", "edit", userPermissions) ? "#3538CD" : "rgba(0, 0, 0, 0.26)"}> Add </Typography>
                                                                </Box>}
                                                        </Box>
                                                    </td>
                                                );
                                            }
                                            if (cell.column.id === "formatted_interested_amount" || cell.column.id === "formatted_allocated_amount") {
                                                const tooltipField = cell?.column?.tooltip;
                                                const currentValue = row?.original[tooltipField];
                                                const currency = currencyList?.find(item => item?._id === row?.original?.currency_id)?.code ?? "₹";
                                                {/* console.log( row.original,"currentValue") */ }
                                                {/* console.log(tooltipField, currency, currentValue, "currentValue") */ }
                                                {/* const removePrefixSuffix = (str) => {
                                                    if (str.startsWith("formatted_")) {
                                                        return str.slice(10); // Remove "formatted_" (10 characters)
                                                    }
                                                    if (str.endsWith("_ref")) {
                                                        return str.slice(0, -4); // Remove "_ref" (4 characters)
                                                    }
                                                    return str;
                                                };
                                                const currentValue = row.original[removePrefixSuffix(cell.column.id)]; */}
                                                {/* console.log(cell.row?.original, "cell?.value") */ }
                                                return (
                                                    <td key={index} {...cell.getCellProps()} style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }} align={cell.column?.align}>

                                                        <Box sx={{
                                                            display: 'grid', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px'
                                                        }}>
                                                            {cell.row?.original?.pipeline_status != "invited" && cell?.value != "" && cell?.value && cell?.value != null && currentValue != "0" && String(cell?.value)?.trim()?.length !== 0 ?
                                                                <Tooltip title={amountInWords(row?.original[tooltipField], currency)}>
                                                                    <Box>
                                                                        <Typography>
                                                                            {cell?.value}
                                                                        </Typography>
                                                                        <Typography fontSize={"0.7rem"}>
                                                                            {cell?.row?.original?.date}
                                                                        </Typography>
                                                                    </Box>
                                                                </Tooltip>
                                                                : ((cell?.row?.original?._id || cell?.row?.original?._id) && cell.column.id !== "formatted_allocated_amount" && hasPermission("startups_new", "edit", userPermissions)) ? <Box onClick={() => { handleShowInterestPopupOpen({ row: cell.row?.original }) }} display={"flex"} alignItems={"center"} justifyContent={"center"} sx={{ textDecoration: "underline", textUnderlineOffset: '5px', textDecorationColor: "#3538CD", cursor: 'pointer' }}>
                                                                    <Add style={{ width: 20, height: 20, color: "#3538CD" }} />
                                                                    <Typography fontSize={"0.9rem"} color={"#3538CD"}> Add </Typography>
                                                                </Box>
                                                                    : "-"}
                                                        </Box>
                                                    </td>
                                                );
                                            }

                                            if (cell?.column?.tooltip) {
                                                const tooltipField = cell?.column?.tooltip;
                                                if (cell?.value == undefined || cell?.value == null || String(cell?.value)?.trim()?.length === 0) {
                                                    return (
                                                        <td
                                                            key={index}
                                                            style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }}
                                                            align={cell.column?.align}
                                                            {...cell.getCellProps()}>
                                                            -
                                                        </td>
                                                    );
                                                }
                                                return (
                                                    <td
                                                        key={index}
                                                        style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }}
                                                        align={cell.column?.align}
                                                        {...cell.getCellProps()}>
                                                        <Tooltip title={row?.original[tooltipField]}>
                                                            {cell.value}
                                                        </Tooltip>
                                                    </td>
                                                );
                                            }
                                            if (cell?.value == undefined || cell?.value == null || String(cell?.value)?.trim()?.length === 0) {
                                                return (
                                                    <td
                                                        key={index}
                                                        style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }}
                                                        align={cell.column?.align}
                                                        {...cell.getCellProps()}>
                                                        {/* {cell.render('Cell')} */}
                                                        -
                                                    </td>
                                                );
                                            }

                                            return (
                                                <td
                                                    key={index}
                                                    style={{ textAlign: cell.column?.align, position: isFixed ? 'sticky' : 'initial', left: isFixed ? 0 : '', zIndex: isFixed ? 1 : 0 }}
                                                    align={cell.column?.align}
                                                    {...cell.getCellProps()}>
                                                    {cell.render('Cell')}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                            {/* {rows?.length === 0 && (
                                (
                                    <tr>
                                        <td colSpan={columns?.length > 0 ? columns?.length : 1} align='center' style={{ textAlign: 'center' }}>{noDataTitle}</td>
                                    </tr>
                                )
                            )} */}
                        </tbody>
                    </table>
                    {/* </TableContainer> */}
                </PerfectScrollbar>
                {(pagination && count > 10) && (
                    <Grid container item xs={12} sx={{
                        padding: '12px 24px 16px 24px', display: 'grid', gridTemplateAreas: isSmallScreen ? `"previous number next"` : `"previous number page span next"`, gridTemplateColumns: isSmallScreen ? '1fr 2fr 1fr' : '1fr 1fr 10fr 1fr 1fr',
                        gridTemplateRows: isSmallScreen ? '1fr' : '1fr', borderTop: `1px solid ${theme.palette.customColors.gray200}`, position: 'sticky', bottom: "-1px", background: theme.palette.customColors.whiteBG,
                        rowGap: 1, columnGap: 1, alignItems: 'center',
                        zIndex: 1000
                    }}>
                        <Grid item display={"flex"} gap={"0.5rem"} gridArea={'previous'}>
                            <Secondary onClick={() => previousPage()} disabled={!canPreviousPage}
                                sx={{
                                    minWidth: "0 !important",
                                    border: `1px solid #D0D5DD !important`,
                                    padding: "8px 14px",
                                    '& > .MuiButton-icon.MuiButton-startIcon': { marginRight: isSmallScreen ? 0 : '8px', marginLeft: isSmallScreen ? 0 : '-4px' }
                                }}
                                startIcon={<PreviousIcon stroke={!canPreviousPage ? '#D0D5DD' : '#344054'} />}
                            >
                                {isSmallScreen ? '' : "Previous"}
                            </Secondary>
                        </Grid>
                        <Grid item gridArea={'number'} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                            <Select
                                value={limit}
                                onChange={(event) => {
                                    setLimit(event.target.value);
                                    setPage(1);
                                }}
                                size="small"
                                IconComponent={DownIcon}
                                sx={{
                                    minWidth: 150,  // Adjust the width as needed
                                    borderRadius: '8px',
                                    border: '1px solid #D0D5DD',  // Border similar to the one in the image
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    color: '#344054',  // Text color
                                    '& .MuiSelect-select': {
                                        padding: '10px 12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                    },
                                    '& .MuiSvgIcon-root': {
                                        marginTop: 0,
                                        color: '#344054',  // Arrow icon color
                                    },
                                    '& > .MuiSelect-icon': {
                                        top: '25%'
                                    },
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: 'none',  // Remove the default border
                                    },
                                }}
                            >
                                {[10, 20, 25, 30, 40, 50]?.map((size) => (
                                    <MenuItem key={size} value={size}>
                                        {size} Per page
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        {!isSmallScreen && <Grid item display={"flex"} justifyContent={"center"} gridArea={'page'}>
                            <Pagination
                                count={Math.ceil(count / limit)}
                                page={page}
                                onChange={(e, value) => {
                                    pageCookieName && Cookies.set(pageCookieName, value)
                                    setPage(value);
                                    // if (Cookies.get("p")) {
                                    //     // searchParams.set('p', value);
                                    //     Cookies.set("p", value)
                                    //     // setSearchParams(searchParams);
                                    // }
                                    // else {
                                    //     // searchParams.append('p', value);
                                    //     // setSearchParams(searchParams);
                                    // }

                                }}
                                shape="rounded"
                                hideNextButton
                                hidePrevButton
                                sx={{
                                    '& .MuiPaginationItem-root': {
                                        color: '#6c757d', // Inactive page color
                                        fontWeight: '500',
                                    },
                                    '& .MuiPaginationItem-root.Mui-selected': {
                                        backgroundColor: 'rgba(138, 75, 244, 0.1)', // Light purple background
                                        color: '#8A4BF4', // Active page color
                                    },
                                    '& .MuiPaginationItem-ellipsis': {
                                        color: '#6c757d', // Ellipsis color
                                    },
                                }}
                            />
                        </Grid>}
                        <Grid item gridArea={'number'} display={"flex"} alignItems={"center"} justifyContent={"center"}></Grid>
                        <Grid item display={"flex"} flexDirection={"row-reverse"} gridArea={'next'}>
                            <Secondary onClick={() => nextPage()} disabled={!canNextPage}
                                sx={{
                                    minWidth: "0 !important",
                                    border: `1px solid #D0D5DD !important`,
                                    padding: "8px 14px",
                                    '& > .MuiButton-icon.MuiButton-endIcon': { marginRight: isSmallScreen ? 0 : '-4px', marginLeft: isSmallScreen ? 0 : '8px' }
                                }}
                                endIcon={<NextIcon stroke={!canNextPage ? '#D0D5DD' : '#344054'} />}
                            >
                                {isSmallScreen ? '' : 'Next'}
                            </Secondary>
                        </Grid>
                    </Grid>
                )}
            </Grid> : <NoData Actions={Actions} sx={{ backgroundColor: theme?.palette.customColors?.whiteBG, ...sx }} title={noDataTitle} subTitle={noDataSubTitle} placeHolderImage={noDataPlaceHolderImage} placeHolderSx={noDataPlaceHolderSx} />}
        </>
    );
};

export default AsyncTableListing;
